<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            Create your Food Fitness First, Inc.® Account
          </h1>
        </div>
      </div>
    </div>

    <div class="container-fluid bg-white-trans py-3 mb-3 mb-sm-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h3 class="text-center">
              <strong>Food Service</strong>
            </h3>
            <p class="lead text-center">
              <strong>Select your membership below to get started!</strong>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <notifications />
      <div class="row d-flex pb-3 pb-sm-5 justify-content-center">
        <div class="col-12 col-md-6 col-lg-6 d-flex align-items-stretch">
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4 class="card-title text-center m-0">
                Partial Food Service Program
              </h4>
            </div>
            <div class="card-body">
              <p class="text-bold">
                Access to limited resources from the following categories
              </p>
              <ul>
                <li v-if="plans">
                  <strong class="text-green">${{ plans.food_service_limited.price }}</strong>/{{ plans.food_service_limited.interval }}
                </li>
                <li>In-Service Education</li>
                <li>Facility Signage/Posters</li>
                <li>Temperature Logs</li>
                <li>Kitchen Forms</li>
                <li>
                  Policies & Procedures Manuals
                  <em>limited</em>
                </li>
                <li>Serve-Safe Guides</li>
              </ul>
            </div>
            <div class="card-footer text-center">
              <router-link
                :to="{name: 'register-paid', params: {type: 'food-service-limited'}}"
                class="btn btn-success btn-md"
              >
                Sign Up
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-6 d-flex align-items-stretch">
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4 class="card-title text-center m-0">
                Full Food Service Program
              </h4>
            </div>
            <div class="card-body">
              <p class="text-bold">
                COMPLETE access to resources from 20+ categories:
              </p>
              <ul>
                <li v-if="plans">
                  <strong class="text-green">${{ plans.food_service_full.price }}</strong>/{{ plans.food_service_full.interval }}
                </li>
                <li>In-Service Education</li>
                <li>Facility Signage/Posters</li>
                <li>Temperature Logs</li>
                <li>Kitchen Forms</li>
                <li>Policies & Procedures Manuals</li>
                <li>Serve-Safe Guides</li>
                <li>
                  <strong>Diet Cards!</strong>
                </li>
                <li>Weekly Menu Templates</li>
                <li>Patient Handouts</li>
                <li>Continuous Quality Manuals</li>
                <li>RD Forms for Consulting</li>
                <li>Standardized Recipes</li>
                <li>PowerPoint Presentations</li>
                <li>And many more useful resources ...</li>
              </ul>
            </div>
            <div class="card-footer text-center">
              <router-link
                :to="{name: 'register-paid', params: {type: 'food-service-full'}}"
                class="btn btn-success btn-md"
              >
                Sign Up
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid bg-white-trans py-3">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <p>
              <em>You may NOT make copies or share Food Fitness First, Inc.® registered information with outside sources. Our program memberships are for individual purchase only. Materials are copyrighted and violators will be prosecuted.</em>
            </p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Plans from '../services/plans.js';
export default {
  data() {
    return {
      plans: null
    }
  },
  mounted(){
    this.fetchPlans();
  },
  methods:{
    fetchPlans(){
      Plans.get().then(res => {
        this.plans = res.data;
      }).catch(err => {
        this.plans = null;
      })
    }
  }
}
</script>
